import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LayoutsComponent } from "./../shared/layouts/layouts.component";
import { AuthGuard } from "../auth/guard/auth.guard";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { UserProfileComponent } from "./user-profile/user-profile.component";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { EnquiriesDashboardComponent } from "./enquiries-dashboard/enquiries-dashboard.component";
import { TestRideDashboardComponent } from "./test-ride-dashboard/test-ride-dashboard.component";
import { FollowupDashboardComponent } from "./followup-dashboard/followup-dashboard.component";
import { ProductivityDashboardComponent } from "./productivity-dashboard/productivity-dashboard.component";
import { LostDashboardComponent } from "./lost-dashboard/lost-dashboard.component";
import { ReportsComponent } from "./reports/reports.component";
import { BiChartComponent } from "../bi-chart/bi-chart.component";
import { DigitalDeskDashboardComponent } from "./digital-desk-dashboard/digital-desk-dashboard.component";
import { ImportUserComponent } from "./import-user/import-user.component";
import { SupportComponent } from "./support/support.component";
import { UsersComponent } from "./users/users.component";
import { DocumentUploadComponent } from "./document-upload/document-upload.component";
import { ProductComponent } from "./product/product.component";
import { EscalationMatrixComponent } from "./escalation-matrix/escalation-matrix.component";

const routes: Routes = [
  {
    path: "",
    component: LayoutsComponent,
    children: [
       {
        path: "products",
        component: ProductComponent,
        canActivate: [AuthGuard],
      },
      // { path: "users", component: UsersComponent, canActivate: [AuthGuard] },
      {
        path: "reset-password",
        component: ResetPasswordComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "change-password",
        component: ChangePasswordComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "user-profile",
        component: UserProfileComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "document-upload",
        component: DocumentUploadComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "escalation-matrix",
        component: EscalationMatrixComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "enquiries-dashboard",
        component: EnquiriesDashboardComponent,
        canActivate: [AuthGuard],
      },
            {
        path: "enquiries-dashboard-new",
        loadChildren: () =>
          import('../core/enquiries-dashboard-new/enquiries-dashboard-new.module').then(
            m => m.EnquiriesDashboardNewModule
          ),
          canActivate: [AuthGuard],
      },
            {
              path: "test-ride-dashboard-new",
              loadChildren: () =>
                import('../core/test-ride-new/test-ride-new.module').then(
                  m => m.TestRideNewModule
                ),
              canActivate: [AuthGuard],
            },
            {
              path: "followup-dashboard-new",
              loadChildren: () =>
                import('../core/followup-new/followup-new.module').then(
                  m => m.FollowupNewModule
                ),
              canActivate: [AuthGuard],
            },
            {
              path: "productivity-dashboard-new",
              loadChildren: () =>
                import('../core/productivity-new/productivity-new.module').then(
                  m => m.ProductivityNewModule
                ),
              canActivate: [AuthGuard],
            },
            {
              path: "lost-dashboard-new",
              loadChildren: () =>
                import('../core/lost-new/lost-new.module').then(
                  m => m.LostNewModule
                ),
              canActivate: [AuthGuard],
            },
            {
              path: "digital-desk-dashboard-new",
              loadChildren: () =>
                import('../core/digital-desk-new/digital-desk-new.module').then(
                  m => m.DigitalDeskNewModule
                ),
              canActivate: [AuthGuard],
            },
            {
              path: "dealer-insight-report",
              loadChildren: () =>
                import('../core/dealer-insight-report/dealer-insight-report.module').then(
                  m => m.DealerInsightReportModule
                ),
              canActivate: [AuthGuard],
            },{
              path: "dealer-visit-report/target-setting",
              loadChildren: () =>
                import('../core/target-setting/target-setting.module').then(
                  m => m.TargetSettingModule
                ),
              canActivate: [AuthGuard],
            },
            {
              path: "dealer-visit-report/report",
              loadChildren: () =>
                import('./target-report/target-report.module').then(
                  m => m.TargetReportModule
                ),
              canActivate: [AuthGuard],
            },
            // {
            //   path: "digital-desk-new",
            //   loadChildren: () =>
            //     import('../core/digital-desk-new/digital-desk-new.module').then(
            //       m => m.DigitalDeskNewModule
            //     ),
            //   canActivate: [AuthGuard],
            // },
            {
              path: "reports-new",
              loadChildren: () =>
                import('../core/reports-new/reports-new.module').then(
                  m => m.ReportsNewModule
                ),
              canActivate: [AuthGuard],
            },
            // {
            //   path: "help-support-new",
            //   loadChildren: () =>
            //     import('../core/help-support-new/help-support-new.module').then(
            //       m => m.HelpSupportNewModule
            //     ),
            //   canActivate: [AuthGuard],
            // },
      {
        path: "test-ride-dashboard",
        component: TestRideDashboardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "followup-dashboard",
        component: FollowupDashboardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "productivity-dashboard",
        component: ProductivityDashboardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "lost-dashboard",
        component: LostDashboardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "reports",
        component: ReportsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "bi-chart",
        component: BiChartComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "digital-desk",
        component: DigitalDeskDashboardComponent,
        canActivate: [AuthGuard],
      },
      // {
      //   path: "upload-users",
      //   component: ImportUserComponent,
      //   canActivate: [AuthGuard],
      // },
      {
        path: "help-and-support",
        component: SupportComponent,
        canActivate: [AuthGuard],
      },
      {
        path: '**', pathMatch: 'full',
        component: PageNotFoundComponent, canActivate: [AuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule { }
